import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createBlock as _createBlock, normalizeStyle as _normalizeStyle, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "pb-16 relative mt-4"
}
const _hoisted_2 = { class: "grid grid-cols-2 gap-x-4 gap-y-8 sm:grid-cols-3 sm:gap-x-6 md:grid-cols-4 lg:grid-cols-3 xl:grid-cols-4 xl:gap-x-8" }
const _hoisted_3 = {
  key: 0,
  class: "pointer-events-none w-full aspect-10/7 bg-gray-200 flex flex-col items-center justify-center gap-2 text-gray-500"
}
const _hoisted_4 = { class: "text-sm" }
const _hoisted_5 = ["poster"]
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = ["onClick", "onContextmenu"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 4,
  class: "absolute bottom-2.5 left-2.5 text-white"
}
const _hoisted_11 = {
  key: 5,
  class: "absolute bottom-2.5 right-2.5 text-white/70"
}
const _hoisted_12 = { class: "absolute top-2 right-2 flex gap-1.5" }
const _hoisted_13 = ["onClick", "disabled"]
const _hoisted_14 = ["onClick", "disabled"]
const _hoisted_15 = {
  key: 0,
  class: "pointer-events-none mt-2 block truncate text-sm font-medium text-gray-900"
}
const _hoisted_16 = {
  key: 1,
  class: "pointer-events-none mt-2 block truncate text-sm font-medium text-gray-900"
}
const _hoisted_17 = { class: "pointer-events-none block text-sm font-medium text-gray-500 flex items-center" }
const _hoisted_18 = { class: "mr-auto" }
const _hoisted_19 = {
  key: 0,
  class: "w-full flex items-center justify-center text-center mx-auto my-4 mt-8 text-gray-600"
}
const _hoisted_20 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_21 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_22 = {
  key: 2,
  class: "text-muted"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PhotosListControlsComponent = _resolveComponent("PhotosListControlsComponent")!
  const _component_StarIcon = _resolveComponent("StarIcon")!
  const _component_StarFilledIcon = _resolveComponent("StarFilledIcon")!
  const _component_VideoCameraIcon = _resolveComponent("VideoCameraIcon")!
  const _component_EyeSlashIcon = _resolveComponent("EyeSlashIcon")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_DeletePhotosConfirmationModalComponent = _resolveComponent("DeletePhotosConfirmationModalComponent")!
  const _component_ContextMenuComponent = _resolveComponent("ContextMenuComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_PhotosListControlsComponent, {
      folder: _ctx.folder,
      selected: _ctx.selected,
      onRemoveSelected: _ctx.removeSelected
    }, null, 8, ["folder", "selected", "onRemoveSelected"]),
    (_ctx.isLoadingPhotos)
      ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
          _createElementVNode("ul", _hoisted_2, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(8, (n) => {
              return _createElementVNode("li", {
                class: "space-y-2",
                key: `skeleton-${n}`
              }, _cache[8] || (_cache[8] = [
                _createElementVNode("div", { class: "skeleton rounded-lg w-full aspect-10/7" }, null, -1),
                _createElementVNode("div", { class: "skeleton rounded h-4 w-3/4" }, null, -1),
                _createElementVNode("div", { class: "flex items-center justify-between" }, [
                  _createElementVNode("div", { class: "skeleton rounded h-4 w-1/4" })
                ], -1)
              ]))
            }), 64))
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isLoadingPhotos)
      ? (_openBlock(), _createElementBlock("section", {
          key: 1,
          class: _normalizeClass({'pb-16 relative': true, 'mt-4': _ctx.selected.length === 0}),
          "aria-labelledby": "gallery-heading",
          ref: "photosContainer"
        }, [
          _createVNode(_component_draggable, {
            modelValue: _ctx.sortedPhotos,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.sortedPhotos) = $event)),
            onStart: _cache[4] || (_cache[4] = ($event: any) => (_ctx.drag=true)),
            onEnd: _cache[5] || (_cache[5] = ($event: any) => (_ctx.drag=false)),
            "item-key": "id",
            tag: "ul",
            role: "list",
            class: _normalizeClass({'grid grid-cols-2 gap-x-4 gap-y-8 sm:grid-cols-3 sm:gap-x-6 md:grid-cols-4 lg:grid-cols-3 xl:grid-cols-4 xl:gap-x-8': true}),
            disabled: _ctx.isSelecting
          }, {
            item: _withCtx(({element, index}) => [
              _createElementVNode("li", {
                class: "relative group cursor-pointer photo-list-item",
                onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onVideoMouseEnter($event))),
                onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onVideoMouseLeave($event))),
                ref: `photo-${index}`
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass([
                        _ctx.isSelectedPhoto(element)
                        ? 'ring-2 ring-royal-blue-500 ring-offset-2'
                        : null,

                        'bg-gray-200 group block w-full overflow-hidden rounded-lg bg-gray-100 relative'])
                }, [
                  (element.is_compressing)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _cache[9] || (_cache[9] = _createElementVNode("svg", {
                          class: "w-6 h-6 animate-spin",
                          xmlns: "http://www.w3.org/2000/svg",
                          fill: "none",
                          viewBox: "0 0 24 24"
                        }, [
                          _createElementVNode("circle", {
                            class: "opacity-25",
                            cx: "12",
                            cy: "12",
                            r: "10",
                            stroke: "currentColor",
                            "stroke-width": "4"
                          }),
                          _createElementVNode("path", {
                            class: "opacity-75",
                            fill: "currentColor",
                            d: "M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                          })
                        ], -1)),
                        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('files.file_is_compressing')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (!element.is_compressing && element.is_video && element.compressed_video_url)
                    ? (_openBlock(), _createElementBlock("video", {
                        key: 1,
                        class: "pointer-events-none w-full aspect-10/7 object-cover transition-transform duration-700 group-hover:scale-105",
                        preload: "metadata",
                        playsinline: "",
                        muted: "",
                        poster: element.preview_url,
                        loop: ""
                      }, [
                        _createElementVNode("source", {
                          src: element.compressed_video_url,
                          type: "video/mp4"
                        }, null, 8, _hoisted_6),
                        _cache[10] || (_cache[10] = _createTextVNode(" Your browser does not support the video tag. "))
                      ], 8, _hoisted_5))
                    : _createCommentVNode("", true),
                  (!element.is_compressing && (!element.is_video || element.compressed_video_url === null))
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 2,
                        src: element.preview_mini_url,
                        alt: element.original_filename,
                        onError: _cache[0] || (_cache[0] = (e) => e.target.src = require(`@/assets/images/img-error.jpg`)),
                        class: _normalizeClass([
                                 _ctx.isSelectedPhoto(element)
                                 ? ''
                                 : 'group-hover:opacity-80',

                                 'pointer-events-none w-full aspect-10/7 object-cover transition-transform duration-700 group-hover:scale-105'])
                      }, null, 42, _hoisted_7))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: "absolute top-0 left-0 right-0 bottom-0",
                    onClick: _withModifiers(($event: any) => (_ctx.select(element, index, $event)), ["prevent"]),
                    onContextmenu: _withModifiers(($event: any) => (_ctx.showContextMenuForPhoto(element, $event)), ["prevent"])
                  }, null, 40, _hoisted_8),
                  (!_ctx.isTrashedFolder)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 3,
                        onClick: ($event: any) => (_ctx.setCover(element)),
                        class: _normalizeClass({'absolute top-2.5 left-2.5 text-white cursor-pointer transition-opacity duration-300': true, 'group-hover:opacity-90 opacity-0 hover:opacity-70': !element.is_cover, 'opacity-90': element.is_cover})
                      }, [
                        (!element.is_cover)
                          ? (_openBlock(), _createBlock(_component_StarIcon, {
                              key: 0,
                              class: "shrink-0 size-5"
                            }))
                          : _createCommentVNode("", true),
                        (element.is_cover)
                          ? (_openBlock(), _createBlock(_component_StarFilledIcon, {
                              key: 1,
                              class: "shrink-0 size-5"
                            }))
                          : _createCommentVNode("", true)
                      ], 10, _hoisted_9))
                    : _createCommentVNode("", true),
                  (element.is_video)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createVNode(_component_VideoCameraIcon, { class: "shrink-0 size-5" })
                      ]))
                    : _createCommentVNode("", true),
                  (element.is_hidden_by_client)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createVNode(_component_EyeSlashIcon, { class: "shrink-0 size-5" })
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_12, [
                    (_ctx.isTrashedFolder)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "text-white bg-royal-blue-500 p-1 rounded-full hover:bg-royal-blue-600 focus:outline-none cursor-pointer transition-opacity duration-300",
                          onClick: _withModifiers(($event: any) => (_ctx.recoverItem(element)), ["prevent"]),
                          disabled: _ctx.isRecoveringDeletedItem
                        }, _cache[11] || (_cache[11] = [
                          _createElementVNode("svg", {
                            class: "shrink-0 size-4",
                            xmlns: "http://www.w3.org/2000/svg",
                            fill: "none",
                            viewBox: "0 0 24 24",
                            "stroke-width": "1.5",
                            stroke: "currentColor"
                          }, [
                            _createElementVNode("path", {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              d: "M9 15 3 9m0 0 6-6M3 9h12a6 6 0 0 1 0 12h-3"
                            })
                          ], -1)
                        ]), 8, _hoisted_13))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      class: _normalizeClass({'text-white bg-red-600 p-1 rounded-full hover:bg-red-700 focus:outline-none cursor-pointer transition-opacity duration-300': true, 'group-hover:opacity-90 opacity-0': !_ctx.isTrashedFolder}),
                      onClick: _withModifiers(($event: any) => (_ctx.deleteItem(element)), ["prevent"]),
                      disabled: _ctx.isDeletingPhoto
                    }, _cache[12] || (_cache[12] = [
                      _createElementVNode("svg", {
                        class: "shrink-0 size-4",
                        xmlns: "http://www.w3.org/2000/svg",
                        fill: "currentColor",
                        viewBox: "0 0 16 16"
                      }, [
                        _createElementVNode("path", { d: "M14 3a.702.702 0 0 1-.037.225l-1.684 10.104A2 2 0 0 1 10.305 15H5.694a2 2 0 0 1-1.973-1.671L2.037 3.225A.703.703 0 0 1 2 3c0-1.105 2.686-2 6-2s6 .895 6 2zM3.215 4.207l1.493 8.957a1 1 0 0 0 .986.836h4.612a1 1 0 0 0 .986-.836l1.493-8.957C11.69 4.689 9.954 5 8 5c-1.954 0-3.69-.311-4.785-.793z" })
                      ], -1)
                    ]), 10, _hoisted_14)
                  ])
                ], 2),
                (_ctx.isTrashedFolder)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(element.deleted_at), 1))
                  : _createCommentVNode("", true),
                (!_ctx.isTrashedFolder)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(element.original_filename), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("p", _hoisted_17, [
                  _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.formatStorage(element.filesize, _ctx.$t)), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(element.folders, (folder, folderIndex) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: `folder-photo-label-${element.id}-${folder.id}-${folderIndex}`,
                      class: "ml-1"
                    }, [
                      (_openBlock(), _createElementBlock("svg", {
                        class: "size-1.5",
                        style: _normalizeStyle({fill: folder.color}),
                        viewBox: "0 0 6 6",
                        "aria-hidden": "true"
                      }, _cache[13] || (_cache[13] = [
                        _createElementVNode("circle", {
                          cx: "3",
                          cy: "3",
                          r: "3"
                        }, null, -1)
                      ]), 4))
                    ]))
                  }), 128))
                ])
              ], 544)
            ]),
            _: 1
          }, 8, ["modelValue", "disabled"]),
          (_ctx.photos.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                (!_ctx.isTrashedFolder && _ctx.folder)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                      _createTextVNode(_toDisplayString(_ctx.$t('files.empty.folders_1')) + " ", 1),
                      _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1)),
                      _createTextVNode(_toDisplayString(_ctx.$t('files.empty.folders_2')), 1)
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.folder && !_ctx.isTrashedFolder)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.$t('files.empty.files')), 1))
                  : _createCommentVNode("", true),
                (_ctx.isTrashedFolder)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.$t('files.empty.trashed')), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.isSelecting)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "selection-box",
                style: _normalizeStyle(_ctx.selectionBoxStyle)
              }, null, 4))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    _createVNode(_component_DeletePhotosConfirmationModalComponent, {
      open: _ctx.isDeletingConfirmation !== null,
      onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isDeletingConfirmation = null)),
      onConfirmAction: _cache[7] || (_cache[7] = ($event: any) => (_ctx.deleteItem(_ctx.isDeletingConfirmation))),
      title: _ctx.$t('files.delete_confirmation_title'),
      message: _ctx.isTrashedFolder ? _ctx.$t('files.delete_confirmation_message') : _ctx.$t('files.delete_confirmation_trash'),
      buttonText: _ctx.$t('files.delete_confirmation_button'),
      isLoading: _ctx.isDeletingPhoto
    }, null, 8, ["open", "title", "message", "buttonText", "isLoading"]),
    _createVNode(_component_ContextMenuComponent, {
      photo: _ctx.contextMenuPhoto,
      folders: _ctx.allFolders,
      "is-visible": _ctx.showContextMenu,
      position: _ctx.contextMenuPosition,
      "is-trashed-folder": _ctx.isTrashedFolder,
      onClose: _ctx.closeContextMenu,
      onDelete: _ctx.handleContextDelete,
      onRecover: _ctx.handleContextRecover,
      onAddToScene: _ctx.handleAddToScene,
      onMakeCover: _ctx.handleMakeCover
    }, null, 8, ["photo", "folders", "is-visible", "position", "is-trashed-folder", "onClose", "onDelete", "onRecover", "onAddToScene", "onMakeCover"])
  ], 64))
}